// extracted by mini-css-extract-plugin
export var cameraTeaserImage = "TeaserCard-module--cameraTeaserImage--c16de";
export var content = "TeaserCard-module--content--fc27d";
export var contentBlock = "TeaserCard-module--contentBlock--cb8e8";
export var contentHidden = "TeaserCard-module--contentHidden--2b808";
export var endContent = "TeaserCard-module--endContent--2a69f";
export var fullWidthOnMobile = "TeaserCard-module--fullWidthOnMobile--233ba";
export var hovered = "TeaserCard-module--hovered--0bffb";
export var imageWrapper = "TeaserCard-module--imageWrapper--a6461";
export var isNewBadge = "TeaserCard-module--isNewBadge--5731d";
export var lightColor = "TeaserCard-module--lightColor--bdd51";
export var noHover = "TeaserCard-module--noHover--7fa95";
export var noSlideDown = "TeaserCard-module--noSlideDown--0124e";
export var teaserBottomContent = "TeaserCard-module--teaserBottomContent--fdd2b";
export var teaserCard = "TeaserCard-module--teaserCard--ecc16";
export var teaserCardLink = "TeaserCard-module--teaserCardLink--66568";
export var teaserContentHeadline = "TeaserCard-module--teaserContentHeadline--b04b4";
export var teaserImage = "TeaserCard-module--teaserImage--3b6aa";
export var teaserTopContent = "TeaserCard-module--teaserTopContent--5b3dd";